import React from 'react';
import { useLanguage } from '../../locale/useLanguage';
import { ComposedMaps, LatLng, MapType, markerIcons } from '../Map/Map';

import './AddressDoorbellPosition.css';

type AddressDoorbellPositionProps = {
  lat: number;
  lng: number;
  address: string;
  onMapClick: (coordinates: LatLng) => void;
};

export const AddressDoorbellPosition: React.FC<
  AddressDoorbellPositionProps
> = ({ lat, lng, onMapClick, address }) => {
  const [t] = useLanguage();

  return (
    <>
      <div className="address-doorbell-position--heading-container">
        <h2 className="subtitle">{t('selectDeliveryPointView.title')}</h2>
        <p className="address-doorbell-position--description">
          {t('selectDeliveryPointView.description')}
        </p>
      </div>
      <ComposedMaps
        isGestureEnabled={true}
        hasZoomControl
        zoom={18}
        mapType={MapType.Satellite}
        centerMap={{ lat, lng }}
        markers={[
          {
            icon: markerIcons.location,
            lat,
            lng,
          },
        ]}
        onClick={onMapClick}
      />
      <div className="address-doorbell-position--address-container">
        <h2 className="subtitle">
          {t('selectDeliveryPointView.selectedAddress')}
        </h2>
        <p className="address-doorbell-position--description">{address}</p>
      </div>
    </>
  );
};
